import { AmountFormat, DateFormat } from 'api'

/* Dates */

export function getDateEditorFormat(dateFormat: DateFormat) {
  switch (dateFormat) {
    case DateFormat.EU:
      return 'dd/MM/yyyy'
    case DateFormat.US:
      return 'MM/dd/yyyy'
    case DateFormat.DD_MMM_YYYY:
      return 'dd MMM yyyy'
    default:
      throw new Error(`Unhandled DateFormat ${[dateFormat]}`)
  }
}

export function getSpreadsheetParsingMomentFormat(dateFormat: DateFormat) {
  switch (dateFormat) {
    case DateFormat.EU:
      return 'D/M/YYYY'
    case DateFormat.US:
      return 'M/D/YYYY'
    case DateFormat.DD_MMM_YYYY:
      return 'D MMM YYYY'
    default:
      throw new Error(`Unhandled DateFormat ${[dateFormat]}`)
  }
}

/* Amounts */

export function getDecimalShift(amountFormat: AmountFormat): number {
  switch (amountFormat) {
    case AmountFormat.ACTUAL:
      return 0
    case AmountFormat.THOUSANDS:
      return 3
    case AmountFormat.MILLIONS:
      return 6
    default:
      throw new Error(`Unhandled AmountFormat [${amountFormat}]`)
  }
}

export function getAmountFormat(decimalShift: number | null): AmountFormat {
  switch (decimalShift) {
    case 0:
    case null:
      return AmountFormat.ACTUAL
    case 3:
      return AmountFormat.THOUSANDS
    case 6:
      return AmountFormat.MILLIONS
    default:
      throw new Error(`Unhandled DecimalShift [${decimalShift}]`)
  }
}

/* Rates */

export const PERCENTAGE_DECIMAL_SHIFT = -2

export const BASIS_POINTS_DECIMAL_SHIFT = -4
